import React, { ChangeEvent, useEffect, useState } from 'react';
import { useHistory, generatePath } from 'react-router-dom';
import { Controller } from 'react-hook-form';
import moment from 'moment';
import { Input, Select, DatePicker } from 'antd';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { find } from 'lodash';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { ROUTE_PACIENTES_FILE } from '../../../../routes.constants';
import {
  inputEmailRules,
  inputIdRules,
  inputPhoneRules,
  inputTextGenericRules,
  requiredRule,
} from './rules';
import { getPaisEntorno } from '../../../../helpers/config.helper';

const { Option } = Select;

interface basicInfoProps{
  camposDinamicos: any,
  watch: boolean,
  hookForms: any,
  intl: any,
  handleChange: any,
  onEdadChange: any,
}

function BasicInfo({
  camposDinamicos, hookForms, intl, watch, handleChange, onEdadChange,
}:basicInfoProps) {
  const history = useHistory();
  const pacienteSelected = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected);
  const tiposIdentificadores = useSelector((state: any) => state.pacientesWorkspace.identificadores);
  const paisesList = useSelector((state: any) => state.pacientesWorkspace.paises);
  const paisesPacienteRequest = useSelector((state: any) => state.sagas.PACIENTES_GET_PACIENTES_PAISES);
  const ambito = useSelector((state: any) => state.auth.user.ambito);
  const breakPoint = useBreakpoint();
  const [country, setCountry] = useState(getPaisEntorno(ambito));
  const [idType, setIdType] = useState<any>(null);

  const {
    register, trigger, setValue, control, errors, watch: watchForm, getValues,
  } = hookForms;

  const genero = watchForm('genero');

  const cellRegister = ((elem: HTMLInputElement | HTMLTextAreaElement | null) => {
    if (watch && elem) elem.disabled = true;
    register(elem);
  });
  useEffect(() => {
    // register('genero', requiredRule(intl, 'genero'));
    register('nombre_1', inputTextGenericRules(intl, 'nombre_1'));
    register('telefono_1', inputPhoneRules(intl, 'telefono_1', control));
    register('telefono_2', inputPhoneRules(intl, 'telefono_2', control));
    //   register('apellido_1', inputTextGenericRules(intl, 'apellido_1'));
    //   register('apellido_2', inputTextGenericRules(intl, 'apellido_2'));
    register('email', inputEmailRules(intl, 'email'));
    //   register('edad', requiredRule(intl, 'edad'));
    register('documento_identidad', inputIdRules(intl, 'documento_identidad', country, idType));
    //   register('fecha_nacimiento', requiredRule(intl, 'fecha_nacimiento'));
  }, [register, country, idType, control]);

  useEffect(() => {
    const documentoIdentidad = getValues('documento_identidad');
    if (!watch && idType !== null && documentoIdentidad) trigger('documento_identidad');
  }, [idType]);
  const removeSinValor = (value: any) => {
    if (value === '<SIN VALOR>' || value === '<SI') return null;
    return value;
  };
  const handleDate = (bornDate: any) => {
    let edad = null;
    if (bornDate) {
      edad = moment().diff(bornDate, 'year');
      setValue('fecha_nacimiento', bornDate);
      setValue('edad', edad);
    } else {
      setValue('edad', null);
      setValue('fecha_nacimiento', null);
    }
    onEdadChange(edad);
    trigger('fecha_nacimiento');

  };
  const handleEdad = (edad: any) => {
    if (edad || edad === 0) {
      setValue('fecha_nacimiento', null);
      setValue('edad', edad);
    }
    onEdadChange(edad);
    trigger('edad');
  };

  useEffect(() => {
    if (genero !== '') {
      control.trigger('genero');
    }
  }, [genero]);

  useEffect(() => {
    if (pacienteSelected && paisesList.length > 0) {
      const {
        cdg_pais_origen,
      } = pacienteSelected;
      setValue('documento_identidad_pais', removeSinValor(cdg_pais_origen));
      setCountry(cdg_pais_origen);
    } else if (country) {
      setValue('documento_identidad_pais', country);
    }
  }, [paisesList]);


  useEffect(() => {
    if (pacienteSelected) {
      const {
        nombre_1, apellido_1, apellido_2, genero, es_empresa, email, fecha_nacimiento, telefono_1, telefono_2, documento_identidad,
        documento_identidad_id, tipo_identificacion_std, cdg_pais_origen,
      } = pacienteSelected;
      setValue('genero', genero);
      setValue('es_empresa', es_empresa);
      setValue('nombre_1', nombre_1);
      setValue('apellido_1', apellido_1);
      setValue('apellido_2', apellido_2);
      setValue('email', email);
      setValue('telefono_1', telefono_1);
      setValue('telefono_2', telefono_2);
      setValue('documento_identidad_id', documento_identidad_id);
      setValue('documento_identidad', documento_identidad);
      setValue('fecha_nacimiento', fecha_nacimiento ? moment(fecha_nacimiento.split(' ')[0], 'DD-MM-YYYY') : null);
      setValue('edad', moment().diff(fecha_nacimiento, 'year'));
      setValue('documento_identidad_pais', cdg_pais_origen);
      setIdType(documento_identidad_id);
    }
  }, [pacienteSelected]);

  useEffect(() => {
    if (tiposIdentificadores.length === 1) {
      setValue('documento_identidad_id', tiposIdentificadores[0].id);
      setIdType(tiposIdentificadores[0].id);
    }
  }, [tiposIdentificadores]);

  function disabledDate(current:any) {
    return watch || (current && current > moment().endOf('day'));
  }

  const getNameErrors = () => {
    if (errors.name || errors.apellido_1 || errors.apellido_2) return true;
    return false;
  };

  const getPhoneErrors = () => {
    if (errors.telefono_1 || errors.telefono_2) return true;
    return false;
  };

  const getDateErrors = () => {
    if (errors.edad || errors.fecha_nacimiento) return true;
    return false;
  };

  const isHidden = (field: string) => {
    const campoPersonalizado = find(camposDinamicos,
      (campoPersonalizado: any) => campoPersonalizado.campo_descripcion === field);
    if (!campoPersonalizado) return false;
    return !campoPersonalizado.propiedades.visible;
  };

  return (
    <div className="bodyInfo flexCol">
      <div className="flexRow spaceBetween">
        <h3>{intl.formatMessage({ id: 'pacientes.generic.titles.basic_info' })}</h3>
        {/* {watch ? (
          <p
            className="blueLink"
            onClick={() => history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId: pacienteSelected.id }))}
          >
            {intl.formatMessage({ id: 'pacientes.new_client.go_back_data' })}
          </p>
        ) : null} */}
      </div>
      <div className="name flexCol">
        <p>{intl.formatMessage({ id: 'pacientes.generic.titles.name_last' })}</p>
        <div className="nameInputs">
          <Input.Group compact>
            <input
              className={`roundedBord ant-input ${getNameErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
              ref={cellRegister}
              name="nombre_1"
              placeholder={intl.formatMessage({ id: 'pacientes.generic.params.nombre_1' })}
              style={{ width: '33.33%' }}
            />
            {!isHidden('apellido_1') && (
            <input
              className={`ant-input ${getNameErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
              ref={cellRegister}
              name="apellido_1"
              placeholder={intl.formatMessage({ id: 'pacientes.generic.params.apellido_1' })}
              style={{ width: '33.33%' }}
            />
            )}
            {!isHidden('apellido_2') && (
            <input
              className={`ant-input ${getNameErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
              ref={cellRegister}
              name="apellido_2"
              placeholder={intl.formatMessage({ id: 'pacientes.generic.params.apellido_2' })}
              style={{ width: '33.33%' }}
            />
            )}
          </Input.Group>
          <div className="firstRowErrors">
            <div>
              {(errors.nombre_1 && (
              <p className="errors">{errors.nombre_1.message}</p>
              ))
            || (errors.apellido_1 && (
              <p className="errors">
                {errors.apellido_1.message}
              </p>
            ))
            || (errors.apellido_2 && (
              <p className="errors">
                {errors.apellido_2.message}
              </p>
            ))}
            </div>
          </div>
        </div>
      </div>
      {!isHidden('email') && (
      <div className="contact">
        <div className="flexCol">
          <p>Email</p>
          <div className="inputMarginTop">
            <input
              ref={cellRegister}
              className={`ant-input ${errors.email ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setValue('email', e.currentTarget.value);
                trigger(['email']);
              }}
              name="email"
              style={{ width: '100%' }}
            />
            <div>
              {errors.email && (
              <p className="errors">{errors.email.message}</p>
              )}
            </div>
          </div>
        </div>
        <div className="flexCol" hidden={isHidden('telefono_1') && isHidden('telefono_2')}>
          <p>{intl.formatMessage({ id: 'pacientes.generic.titles.phones' })}</p>
          <div className="inputMarginTop">
            <Input.Group compact>
              {!isHidden('telefono_1') && (
              <input
                hidden={isHidden('telefono_1')}
                className={`ant-input ${getPhoneErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                placeholder={intl.formatMessage({ id: 'pacientes.generic.titles.telefono_1' })}
                ref={cellRegister}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setValue('telefono_1', e.currentTarget.value);
                  trigger(['telefono_1', 'telefono_2']);
                }}
                name="telefono_1"
                type="tel"
                style={{ width: '50%' }}
              />
              )}
              {!isHidden('telefono_2') && (
              <input
                className={`ant-input ${getPhoneErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                placeholder={intl.formatMessage({ id: 'pacientes.generic.titles.telefono_2' })}
                ref={(e) => {
                  if (watch && e) e.disabled = true;
                  if (e && country === 'ES') register(e, inputPhoneRules(intl, e?.name, control));
                }}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setValue('telefono_2', e.currentTarget.value);
                  trigger(['telefono_1', 'telefono_2']);
                }}
                name="telefono_2"
                type="tel"
                style={{ width: '50%' }}
              />
              )}
            </Input.Group>
            <div>
              {(errors.telefono_1 && (
              <p className="errors">{errors.telefono_1.message}</p>
              ))
              || (errors.telefono_2 && (
              <p className="errors">{errors.telefono_2.message}</p>
              ))
              }
            </div>
          </div>
        </div>
      </div>
      )}

      <div className="contact">
        {!isHidden('documento_identidad') && (
          <div className="flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.generic.titles.documento_identidad' })}</p>
            <div id="prueba1" className="inputMarginTop">

              <Input.Group compact>
                <Controller
                  name="documento_identidad_id"
                  control={control}
                  render={
                    ({
                      name, value,
                    }) => (
                      <Select
                        dropdownStyle={{ minWidth: 'fit-content' }}
                        className={`patient-new ${errors.documento_identidad ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                        getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                          ? trigger.parentElement : null)}
                        style={breakPoint.isTablet ? { width: '30%' } : { width: '20%' }}
                        onSelect={(value: any, tipoDocumento:any) => {
                          handleChange(name, value);
                          setIdType(parseInt(tipoDocumento.key, 10));
                        }}
                        disabled={watch}
                        value={value}
                      >
                        {tiposIdentificadores.map((element:any) => (
                          <Option key={element.id} value={element.id}>{element.descripcion}</Option>
                        ))
                        }
                      </Select>
                    )}
                />
                <input
                  className={`ant-input ${errors.documento_identidad ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                  ref={cellRegister}
                  name="documento_identidad"
                  type="numeric"
                  autoComplete="off"
                  style={breakPoint.isTablet ? { width: '40%' } : { width: '60%' }}
                />
                <Controller
                  name="documento_identidad_pais"
                  control={control}
                  render={
                    ({
                      name, value,
                    }) => (
                      <Select
                        className={`${errors.documento_identidad ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                        getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                          ? trigger.parentElement : null)}
                        defaultValue={paisesList.length > 0 && pacienteSelected ? getPaisEntorno(ambito) : null}
                        style={breakPoint.isTablet ? { width: '30%' } : { width: '20%' }}
                        loading={paisesPacienteRequest && paisesPacienteRequest.running}
                        onSelect={(value:string) => {
                          handleChange(name, value);
                          setCountry(value);
                        }}
                        disabled={watch}
                        dropdownMatchSelectWidth={false}
                        value={value}
                        showSearch
                        filterOption={(inputValue: string, option: any) => option.props.children.toUpperCase().includes(inputValue.toUpperCase())}
                      >
                        {paisesList.map((pais:any) => (
                          <Option key={pais.idAlfa2} value={pais.idAlfa2}>{`${pais.idAlfa3} - ${pais.nombre}`}</Option>
                        ))
                  }
                      </Select>
                    )}
                />

              </Input.Group>
            </div>
            <div>
              {(errors.documento_identidad && (
                <p className="errors">{errors.documento_identidad.message}</p>
              ))
              }
            </div>
          </div>
        )}

        <div className="flexCol">
          <p>{intl.formatMessage({ id: 'pacientes.generic.titles.age_born' })}</p>
          <div className="inputMarginTop">
            <Input.Group compact>
              {!isHidden('edad') && (
                <input
                  placeholder={intl.formatMessage({ id: 'pacientes.generic.titles.edad' })}
                  className={`ant-input ${getDateErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                  onChange={e => handleEdad(e.target.value)}
                  // TODO: VER ESTO
                  name="edad"
                  type="number"
                  style={{ width: '50%' }}
                  ref={cellRegister}
                />
              )}
              {/* // TODO: Review controller on watch */}
              {!isHidden('fecha_nacimiento') && (
                <Controller
                  name="fecha_nacimiento"
                  render={
                    ({
                      name, onChange, value,
                    }) => (
                      <DatePicker
                        className={`${getDateErrors() ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                        onChange={(e) => {
                          onChange(e);
                          setValue(name, e?.toISOString());
                          handleDate(e);
                        }}
                        getCalendarContainer={(trigger: Element): any => (trigger.parentElement
                          ? trigger.parentElement : null)}
                        style={{ width: '50%' }}
                        placeholder="dd-mm-yyyy"
                        format="DD-MM-YYYY"
                        disabledDate={disabledDate}
                        disabled={watch}
                        value={value ? moment(value) : null}
                      />
                    )
                  }
                  control={control}
                />
              )
              }
            </Input.Group>
          </div>
          <div>
            {(errors.edad && (
              <p className="errors">{errors.edad.message}</p>
            ))
            || (errors.fecha_nacimiento && (
              <p className="errors">{errors.fecha_nacimiento.message}</p>
            ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(BasicInfo);
